import { render, staticRenderFns } from "./MemberStatistics.vue?vue&type=template&id=fc2043ae&scoped=true&"
import script from "./MemberStatistics.vue?vue&type=script&lang=js&"
export * from "./MemberStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MemberStatistics.vue?vue&type=style&index=0&id=fc2043ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2043ae",
  null
  
)

export default component.exports